import { createContext, useContext } from 'react';

const MaximumDropzoneTextLength = /*#__PURE__*/createContext(0);
function useMaximumDropzoneTextLength() {
  return useContext(MaximumDropzoneTextLength);
}

export { MaximumDropzoneTextLength, useMaximumDropzoneTextLength };
//# sourceMappingURL=context.js.map
